import { createReducer, on } from "@ngrx/store";
import { IAppAppearance } from "../../models/white-labeling.model";
import { wlbActions } from "./white-labeling.actions.list";
import { IAppState } from "../../models/app.model";

export type whiteLabelingState = IAppState<IAppAppearance>;

export const initialState: whiteLabelingState = {
  data: null,
  isLoading: false,
  error: null,
};

export const whiteLabelingReducer = createReducer(
  initialState,
  on(
    wlbActions.load,
    (state): whiteLabelingState => ({
      ...state,
      isLoading: true,
      error: null,
      data: null,
    }),
  ),
  on(
    wlbActions.success,
    (state, { response }): whiteLabelingState => ({
      ...state,
      isLoading: false,
      data: response,
      error: null,
    }),
  ),
  on(
    wlbActions.failure,
    (state, { error }): whiteLabelingState => ({
      ...state,
      isLoading: false,
      data: null,
      error,
    }),
  ),
);
